import type { SortValue } from '@/components/common/SortDrawer';

export type UserAccessListSearchState = {
  showDeactivated: boolean;
  sort: SortValue[];
};

export function getUserAccessListSearchParams(params: URLSearchParams): UserAccessListSearchState {
  const sort = params.get('sort');

  return {
    showDeactivated: params.get('showDeactivated') === 'true',
    sort:
      sort === 'name:asc' || sort === 'name:desc'
        ? [{ field: 'name', direction: sort === 'name:desc' ? 'desc' : 'asc' }]
        : [],
  };
}

export function withUserAccessListSearchParams(
  current: URLSearchParams,
  changes: Partial<UserAccessListSearchState>
): URLSearchParams {
  const next = new URLSearchParams(current);

  if (changes.showDeactivated !== undefined) {
    if (changes.showDeactivated) next.set('showDeactivated', 'true');
    else next.delete('showDeactivated');
  }
  if (changes.sort !== undefined) {
    const nameSort = changes.sort.find((item) => item.field === 'name');
    if (nameSort) next.set('sort', `name:${nameSort.direction}`);
    else next.delete('sort');
  }

  return next;
}
